import React, { useMemo } from "react";
import AppliedActionCard from "./AppliedActionCard";
import { ACTION_CARD_HEADER_HEIGHT, ACTION_CARD_HEADER_OVERLAP } from "../../utils/stockCardUtils";

/**
 * AppliedActionCardStack - Manages stacking of multiple applied action cards
 * Cards are positioned underneath the stock card with headers peeking out above
 * Newest cards are closest to the stock card (highest z-index)
 */
const AppliedActionCardStack = ({ 
  appliedActionCards, 
  styleCardSize,
  playerColors = {},
  playerEmojis = {}
}) => {
  // Calculate total height needed for action card headers above
  const actionCardsHeight = useMemo(() => {
    return appliedActionCards.length > 0 
      ? ACTION_CARD_HEADER_HEIGHT + (appliedActionCards.length - 1) * (ACTION_CARD_HEADER_HEIGHT - ACTION_CARD_HEADER_OVERLAP)
      : 0;
  }, [appliedActionCards.length]);

  // Reverse array so newest cards appear on top (closest to stock card)
  // Must call useMemo before any early returns to follow React Hooks rules
  const reversedCards = useMemo(() => {
    return [...appliedActionCards].reverse();
  }, [appliedActionCards]);

  if (appliedActionCards.length === 0) {
    return null;
  }

  return (
    <div className="applied-action-card-stack">
      {reversedCards.map((actionCard, index) => {
        const offset = index * (ACTION_CARD_HEADER_HEIGHT - ACTION_CARD_HEADER_OVERLAP);
        const zIndex = index + 1; // Newest card (index 0) gets zIndex 1, oldest gets highest

        return (
          <AppliedActionCard
            key={`applied-${actionCard.name}-${index}-${actionCard.playerName || ''}-${actionCard.effectValue || ''}`}
            actionCard={actionCard}
            styleCardSize={styleCardSize}
            offset={offset}
            zIndex={zIndex}
            playerColors={playerColors}
            playerEmojis={playerEmojis}
          />
        );
      })}
    </div>
  );
};

export default AppliedActionCardStack;

